<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

      <!-- Brand logo-->
      <b-link class="brand-logo">
        <!-- <b-img
          :src="appLogoImage"
          alt="logo"
          width="100px"
          height="100px"
        /> -->
        <!-- <h2 class="brand-text text-primary ml-1">
          {{ appName }}
        </h2> -->
      </b-link>
      <!-- /Brand logo-->

      <!-- Left Text-->
      <b-col
        lg="8"
        class="d-none d-lg-flex align-items-center p-5"
      >
        <div class="w-100 d-lg-flex align-items-center justify-content-center px-5">
          <b-img
            fluid
            :src="imgUrl"
            alt="Login V2"
          />
        </div>
      </b-col>
      <!-- /Left Text-->

      <!-- Login-->
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <div class="algin-center">
            <b-img
              :src="appLogoImage"
              class="mb-4"
              alt="logo"
              width="auto"
              height="230px"
            />
          </div>
          <b-card-title
            title-tag="h6"
            class="font-weight-bold mb-1 d-flex align-items-center justify-content-center"
          >
            <!-- Bienvenue sur {{ appName }} ! -->
            Veuillez vous connecter à votre compte

            <!-- Bouton de configuration -->
            <b-button
              v-ripple.400="'rgba(255, 255, 255, 0.15)'"
              variant="primary"
              class="btn-icon rounded-circle mt-0 inline-block ml-auto"
              @click="visibleconf = !visibleconf"
            >
              <feather-icon icon="SettingsIcon" />
            </b-button>
          </b-card-title>

          <!-- Formulaire de configuration -->
          <b-collapse id="collapse-1" class="mt-0 mb-4" v-model="visibleconf">
            <!-- <b-card class="border mb-0"> -->
              <b-form>
                <b-form-group
                  label="URL"
                  label-for="url"
                  hidden
                  >
                    <b-form-input
                      id="url"
                      v-model="url"
                      name="url"
                      placeholder="https://mondomaine.fr"
                      type="url"
                      required
                      autocapitalize="off"
                    />
                </b-form-group>
                <b-form-group
                  label="Base"
                  label-for="database"
                  >
                    <b-form-input
                      id="database"
                      v-model="database"
                      name="database"
                      placeholder=""
                      required
                      autocapitalize="off"
                    />
                </b-form-group>
                <b-button
                    type="submit"
                    variant="success"
                    block
                    @click="saveConfig"
                  >
                    Enregistrer la configuration
                  </b-button>
              </b-form>
            <!-- </b-card> -->
          </b-collapse>

          <!-- <b-card-text class="mb-2">
            Veuillez vous connecter à votre compte
          </b-card-text> -->

          <!-- form -->
          <b-collapse id="collapse-2" class="mt-0 mb-4" v-model="visible">
            <validation-observer ref="loginValidation">
              <b-form
                class="auth-login-form mt-2"
                @submit.prevent
              >
                <!-- email -->
                <b-form-group
                  label="Email"
                  label-for="login-email"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Email"
                    rules="required|email"
                  >
                    <b-form-input
                      id="login-email"
                      v-model="userEmail"
                      :state="errors.length > 0 ? false:null"
                      name="login-email"
                      placeholder="john@example.com"
                      autocapitalize="off"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <!-- forgot password -->
                <b-form-group>
                  <div class="d-flex justify-content-between">
                    <label for="login-password">Mot de passe</label>
                    <!--<b-link >
                      <small>Forgot Password?</small>
                    </b-link>-->
                  </div>
                  <validation-provider
                    #default="{ errors }"
                    name="Mot de passe"
                    rules="required"
                  >
                    <b-input-group
                      class="input-group-merge"
                      :class="errors.length > 0 ? 'is-invalid':null"
                    >
                      <b-form-input
                        id="login-password"
                        v-model="password"
                        :state="errors.length > 0 ? false:null"
                        class="form-control-merge"
                        :type="passwordFieldType"
                        name="login-password"
                        placeholder="············"
                      />
                      <b-input-group-append is-text>
                        <feather-icon
                          class="cursor-pointer"
                          :icon="passwordToggleIcon"
                          @click="togglePasswordVisibility"
                        />
                      </b-input-group-append>
                    </b-input-group>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>

                <!-- checkbox -->
                <!--<b-form-group>
                  <b-form-checkbox
                    id="remember-me"
                    v-model="status"
                    name="checkbox-1"
                  >
                    Se rappeler de moi
                  </b-form-checkbox>
                </b-form-group>-->

                <!-- submit buttons -->
                <b-button
                  type="submit"
                  variant="primary"
                  block
                  @click="validationForm"
                >
                  Se connecter
                </b-button>
              </b-form>
            </validation-observer>
          </b-collapse>

          <!--<b-card-text class="text-center mt-2">
            <span>New on our platform? </span>
            <b-link >
              <span>&nbsp;Create an account</span>
            </b-link>
          </b-card-text>-->

        </b-col>
      </b-col>
    <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import {
  BRow, BCol, BLink, BFormGroup, BFormInput, BInputGroupAppend, BInputGroup, BFormCheckbox, BCardText, BCardTitle, BImg, BForm, BButton, BCollapse, BCard, VBToggle
} from 'bootstrap-vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { $themeConfig } from '@themeConfig'
import PouchDB from 'pouchdb'
import PouchdbAuthentication from 'pouchdb-authentication'
PouchDB.plugin(PouchdbAuthentication)

export default {
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    ValidationProvider,
    ValidationObserver,
    BCollapse,
    BCard
  },
  directives: {
    'b-toggle': VBToggle,
  },
  mixins: [togglePasswordVisibility],
  setup() {
    // App Name
    const { appName, appLogoImage } = $themeConfig.app
    return {
      appName,
      appLogoImage,
    }
  },
  data() {
    return {
      status: '',
      info: '',
      password: '',
      userEmail: '',
      sideImg: require('@/assets/images/pages/login-v2.svg'),
      localDB: '',
      remoteDB: '',
      sessionDB: '',
      // validation rulesimport store from '@/store/index'
      required,
      email,
      url: process.env.VUE_APP_DB_URL || 'https://couchdb.burotica.fr',
      database: '',
      visibleconf: false,
      visible: true
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/pages/login-v2-dark.svg')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  created() {
    if( localStorage.getItem('url') ) { this.url = localStorage.getItem('url') }
    if( localStorage.getItem('database') ) { this.database = localStorage.getItem('database') }
    if( localStorage.getItem('commercial') ) { this.userEmail = (JSON.parse(localStorage.getItem('commercial')).id).replace('org.couchdb.user:', '') }

    console.log('email', this.userEmail);

    if (!localStorage.getItem('url') || !localStorage.getItem('database')) {
      this.visibleconf = true
      this.visible = false
      this.$toast({
        component: ToastificationContent,
        position: 'top-right',
        props: {
          title: 'Configuration',
          icon: 'CoffeeIcon',
          variant: 'danger',
          text: 'Merci de renseigné la configuration',
        },
      })
    }

    localStorage.removeItem(localStorage.user)
    localStorage.removeItem(localStorage.role)
  },
  methods: {
    validationForm() {
      this.$refs.loginValidation.validate().then(success => {
        if (success) {
          this.localDB = new PouchDB(localStorage.getItem('database'))
          this.remoteDB = new PouchDB(localStorage.getItem('url')+'/'+localStorage.getItem('database'), { skip_setup: true })
          this.sessionDB = new PouchDB(localStorage.getItem('url')+'/_session')
          this.sessionDB.logIn(this.userEmail, this.password).then(response => {
            console.log('logIn', response)
            // alert("logIn" + JSON.stringify(response))

            this.sessionDB.getSession().then(response => {
              console.log('getSession', response)
              if (!response.userCtx.name) {
                console.log("Personne n'est connecté")
              } else if (response.userCtx.roles.includes(localStorage.getItem('database')) != true) {
                console.log('Utilisateur non autorisé', response.userCtx.roles.includes(localStorage.getItem('database')))
                this.$toast({
                  component: ToastificationContent,
                  position: 'top-right',
                  props: {
                    title: 'Erreur d\'authentification',
                    icon: 'CoffeeIcon',
                    variant: 'danger',
                    text: 'Compte non autorisé.',
                  },
                })
              } else {
                localStorage.setItem('user', response.userCtx.name)
                localStorage.setItem('role', response.userCtx.roles)

                this.$router.push({ path: '/syncdb' })
              }
            })
          })
          .catch(error => {
            console.error('errorresponse', error)
            if (!error.error) {
              // network error
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: 'Erreur d\'authentification',
                  icon: 'CoffeeIcon',
                  variant: 'danger',
                  text: 'Pas de connexion internet.',
                },
              })
              this.errorStatus = 'Error: Network Error';
            } else {
              this.$toast({
                component: ToastificationContent,
                position: 'top-right',
                props: {
                  title: 'Erreur d\'authentification',
                  icon: 'CoffeeIcon',
                  variant: 'danger',
                  text: 'Vérifiez votre email ou mot de passe.',
                },
              })
              this.errorStatus = error.message;
            }
            console.error('error', this.errorStatus)

          })

          // this.localDB.sync(this.remoteDB, { live: true, retry: true }).on('error', console.log.bind(console))
        }
      })
    },
    saveConfig() {
      localStorage.clear()
      localStorage.setItem('url', this.url)
      localStorage.setItem('database', this.database)
    }
  },
}
</script>

<style>
  .card .card-header {
    padding: 0.5rem;
  }
  .card .card-header .card-title {
    font-size: 1rem;
    padding-left: 1rem
  }
</style>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';
</style>
